// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitCustomControlCalendarToggle-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendarToggle.desktop.scss
 ** module id = 934
 ** module chunks = 1
 **/